import { FormControl, Validators,FormGroup } from "@angular/forms";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from '@angular/material/snack-bar';

import { DialogActions } from 'src/app/components/dialogs/dialog.model';
import { OnboardingService } from "src/app/services/onboarding.service";
import { SnackbarComponent } from '../snackbar/snackbar.component';

import { SettingsService } from './../../services/settings.service';
import { LoginModel } from "src/app/models/login.model";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-account-detail-popup",
  templateUrl: "./account-detail-popup.component.html",
  styleUrls: ["./account-detail-popup.component.scss"],
})
export class AccountDetailPopupComponent implements OnInit,OnDestroy {
  spin:boolean = false;
  actions: DialogActions[];
  disabledForm: FormGroup = new FormGroup({
    name: new FormControl({ value: "", disabled: true }),
    seller: new FormControl({ value: "", disabled: true }),
    marketplaceID: new FormControl({ value: "", disabled: true }),
  });
  form: FormGroup = new FormGroup({
    deductStock: new FormControl(""),
    mwsToken: new FormControl({ value: "", disabled: true }),
    syncPct: new FormControl("", [Validators.min(0), Validators.max(100)]),
    safetyStock: new FormControl("", [Validators.min(0)]),
    defaultMax: new FormControl("", [Validators.min(0)]),
    syncInventory: new FormControl(""),
    defaultWarehouseId: new FormControl(""),
    hanldingTime:new FormControl(null),
    includeNarfOrders: new FormControl(false),
    deductWarehouseId:new FormControl("")
  },
  {
    validators: [this.validateSyncPct("syncPct", "syncInventory")],
  }
  );
  warehouses: any[];
  isYardener: number;
  isPlanyard: number;
  user:LoginModel
  private destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<AccountDetailPopupComponent>,
    private onboardingService: OnboardingService,
    private snackBar: MatSnackBar,
    private settingsService: SettingsService
  ) {}

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem("User")) as LoginModel;
    this.isYardener = this.user.isYardener;
    this.isPlanyard = this.user.isPlanYard;
    this.data.account.defaultWarehouseId = this.data.account.defaultWarehouseId || "";
    this.disabledForm.patchValue(this.data.account);
    this.form.patchValue(this.data.account);
    this.settingsService.GetAllWarehouses().pipe(takeUntil(this.destroy$)).subscribe((res: any[]) => {
      this.warehouses = res;
      if(this.warehouses?.length){
        if(this.data?.account?.deductWarehouseId){
          const index = this.warehouses.findIndex(x => x.warehouseId === this.data.account.deductWarehouseId);
          if (index !== -1) {
              this.form.get('deductWarehouseId').setValue(this.warehouses[index].warehouseId);
          }
        }
      }
    });
  }

  close() {
    this.dialogRef.close();
  }

  action(e) {
    if(e === "Save"){
      this.save();
    } else if (e === "Cancel" || e === "Close") {
      this.close();
    }
  }

  save() {
    this.spin = true;
    const payload = this.form.getRawValue();
    payload.safetyStock =payload.safetyStock;
    payload.accountName = this.data.account.name;
    payload.deductWarehouseId = Number(this.form.value.deductWarehouseId)

    this.onboardingService.UpdateAccountSettings(payload).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res) => {
          this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 3000,
              horizontalPosition: 'center',
              data: {
                title: 'Account settings updated successfully',
                action: 'Dismiss',
                type: 'success',
              },
            }
        );
          
        this.dialogRef.close('Saved');
        },
       error: (err) => {
         this.spin = false;
         const key=Object.keys(err.error.errors)[0];
         this.snackBar.openFromComponent(SnackbarComponent,
           {
             duration: 3000,
             horizontalPosition: 'center',
             data: {
               title: err.error.errors[key][0],
               action: 'Dismiss',
               type: 'error',
             },
           }
         );
       }
     });
  }

  validateSyncPct(syncPct: string, syncInventory: any): any {
    return (group: FormGroup) => {
      const syncInput = group.controls[syncPct];
      const syncInventoryToggle = group.controls[syncInventory];
      if (!syncInput.value &&  syncInventoryToggle.value) {
          syncInput.markAsTouched();
        return  syncInput.setErrors(Validators.required);       
      } else {
        return syncInput.setErrors(null);
      }
    };
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
